import {
  Button,
  Typography,
  Chip,
  Collapse,
  Box,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import PreviewPdfUrl from "../comm/PreviewPdfUrl";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  getInternshipApplications,
  updateInternshipApplication,
  updateInternshipApplicationDocuments,
  confirmInternshipApplicationCorrection,
  respondToPlacementOffer,
  getPlacementRejectionReasons,
  getPlacementRejectionLogs,
  getApplicationPlacements,
} from "../../store/applicant/actions";
import {
  getCountries,
  getDegrees,
  getEducationalInstitutions,
  getQualifications,
  getQualificationGrades,
  getBanks,
} from "../../store/profile/actions";
import NoResults from "../comm/NoResults";
import SearchBox from "../comm/SearchBox";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";

import AdvertSkeleton from "../comm/AdvertSkeleton";
// Do not use ApplicationItem here; custom card is implemented below
import ProfileSummary from "./profile/components/ProfileStatus";
import { useHistory } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DescriptionIcon from "@mui/icons-material/Description";
import EventIcon from "@mui/icons-material/Event";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import EditIcon from "@mui/icons-material/Edit";
import DialogModel from "../comm/DialogModel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Alert, Popover } from "@mui/material";
import { AlertTitle } from "@mui/lab";
import { showError, showSuccess } from "../toastify";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import GroupIcon from "@mui/icons-material/Group";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

export const InternshipApplications = (props) => {
  const {
    loading,
    internshipApplications,
    getInternshipApplications,
    lookup,
    getCountries,
    getDegrees,
    getEducationalInstitutions,
    getQualifications,
    getQualificationGrades,
    getBanks,
    updateInternshipApplication,
    updateInternshipApplicationDocuments,
    confirmInternshipApplicationCorrection,
    respondToPlacementOffer,
    getPlacementRejectionReasons,
    placementRejectionReasons,
    getPlacementRejectionLogs,
    placementRejectionLogs,
    getApplicationPlacements,
    applicationPlacements,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState("");
  const [allHidden, setAllHidden] = useState(0);
  const [showHidden, setShowHidden] = useState(0);
  const [showDocument, setShowDocument] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(null);
  const [isBase64, setIsBase64] = useState(false);

  // Edit modal states
  const [editMenuAnchor, setEditMenuAnchor] = useState(null);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showEditEducation, setShowEditEducation] = useState(false);
  const [showEditBank, setShowEditBank] = useState(false);
  const [showEditDocuments, setShowEditDocuments] = useState(false);

  // Popover state for confirm button
  const [applicationWithEdit, setApplicationWithEdit] = useState(null);

  useEffect(() => {
    // update page title
    document.title = "Internship Applications | Jobs";
  }, []);

  // Auto-hide popover after 5 seconds
  useEffect(() => {
    if (applicationWithEdit) {
      const timer = setTimeout(() => {
        setApplicationWithEdit(null);
      }, 15000);
      return () => clearTimeout(timer);
    }
  }, [applicationWithEdit]);

  useEffect(() => {
    // Filter applications - only show internship applications

    const normalizedSearch = (searchInput || "")
      .replace(/\s/g, "")
      .toLowerCase();

    // Then apply search filter using internship fields
    const filtered = internshipApplications.filter((application) => {
      const searchable = [
        application.applicationId,
        application.firstName,
        application.lastName,
        application.bankName,
        application.degreeName,
        application.qualificationName,
        application.qualificationGrade,
        application.schoolName,
        application.applicationStatus,
        application.statusId != null ? String(application.statusId) : "",
        application.waitingPosition != null
          ? String(application.waitingPosition)
          : "",
        application.totalWaitingListIntern != null
          ? String(application.totalWaitingListIntern)
          : "",
      ]
        .filter(Boolean)
        .join(" ")
        .replace(/\s/g, "")
        .toLowerCase();

      return searchable.includes(normalizedSearch);
    });

    setFilteredJobs(filtered);
  }, [internshipApplications, searchInput]);

  useEffect(() => {
    getInternshipApplications(showHidden, setAllHidden);
  }, [showHidden]);

  useEffect(() => {
    getPlacementRejectionReasons();
  }, []);

  useEffect(() => {
    if (!lookup?.countries) getCountries();
    if (!lookup?.degrees) getDegrees();
    if (!lookup?.qualificationGrades) getQualificationGrades();
    if (!lookup?.banks) getBanks();
  }, []);

  const randomArray = Array.from({ length: 10 }, () =>
    Math.floor(Math.random() * 10),
  );
  // console.log(internshipApplications[0]);
  const [filteredJobs, setFilteredJobs] = useState([]);

  const buildPreviewUrlFromDocRef = (docReferenceId) => {
    if (!docReferenceId) return null;
    return (
      (process.env.REACT_APP_FILES_URL || "") + "/preview/" + docReferenceId
    );
  };

  const handlePreviewByDocRef = (docReferenceId, title) => {
    const url = buildPreviewUrlFromDocRef(docReferenceId);
    if (!url) return;
    setPreviewDocument({ name: title, url });
    setIsBase64(false);
    setShowDocument(true);
  };

  const handleEditClick = (event, application, section) => {
    setSelectedApplication(application);
    if (section === "education") {
      setShowEditEducation(true);
    } else if (section === "bank") {
      setShowEditBank(true);
    } else if (section === "documents") {
      setShowEditDocuments(true);
    } else {
      // Fallback to menu if no section specified
      setEditMenuAnchor(event.currentTarget);
    }
  };

  const handleEditMenuClose = () => {
    setEditMenuAnchor(null);
  };

  const openEditEducation = () => {
    setShowEditEducation(true);
    handleEditMenuClose();
  };

  const openEditBank = () => {
    setShowEditBank(true);
    handleEditMenuClose();
  };

  const openEditDocuments = () => {
    setShowEditDocuments(true);
    handleEditMenuClose();
  };

  // console.log(internshipApplications)
  return (
    <div className="row mx-0 mt-4">
      <div className="col-12 col-sm-8 col-md-9 order-last order-sm-first mt-sm-0 px-1 px-sm-3">
        <section className="card mb-3 elevated rounded border border-primary bg-light">
          <div>
            <div className="card-header bg-light rounded-top font-weight-bold ">
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <Typography
                    variant="h6"
                    component="h2"
                    className={`text-uppercase ${
                      showHidden ? "text-danger" : ""
                    }`}
                    aria-labelledby="my-internship-application-list"
                  >
                    <span className="mr-2">
                      My Internship Applications ({filteredJobs.length})
                    </span>
                  </Typography>
                </div>

                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <Button
                      variant="text"
                      startIcon={<HelpOutlineIcon />}
                      size="medium"
                      className="mr-4"
                      onClick={() => {
                        history.push(
                          "/applicant/internship-application-guidelines",
                        );
                      }}
                    >
                      Guidelines
                    </Button>
                    <Button
                      variant="contained"
                      startIcon={<SchoolIcon />}
                      size="medium"
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: "8px",
                        px: 3,
                        py: 1,
                        mr: 2,
                        backgroundColor: "oklch(52.7% 0.154 150.069)",
                        color: "#ffffff",
                        boxShadow: 2,
                        "&:hover": {
                          backgroundColor: "oklch(44.8% 0.119 151.328)",
                          boxShadow: 4,
                        },
                      }}
                      onClick={() => {
                        history.push("/applicant/internship-application-new");
                      }}
                    >
                      Apply
                    </Button>
                    <SearchBox
                      placeholder="Search..."
                      disabled={!internshipApplications.length || loading}
                      onSearch={setSearchInput}
                      role="search"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="card-body"
              role="list"
              id="my-internship-application-list"
            >
              {loading && !internshipApplications.length ? (
                randomArray.map((item) => (
                  <div
                    className="mb-3"
                    key={item + Math.random() * 11}
                    role="listitem"
                  >
                    <AdvertSkeleton />
                  </div>
                ))
              ) : filteredJobs.length ? (
                filteredJobs.map((application, index) => (
                  <div
                    className="mb-3"
                    key={application.id || application.applicationId}
                    role="listitem"
                  >
                    <InternshipCard
                      setApplicationWithEdit={setApplicationWithEdit}
                      application={application}
                      defaultExpanded={index === 0}
                      onEdit={(event, app, section) =>
                        handleEditClick(event, app, section)
                      }
                      onPreview={(docRef, title) =>
                        handlePreviewByDocRef(docRef, title)
                      }
                      showConfirmPopover={
                        applicationWithEdit === application.applicationId
                      }
                      confirmInternshipApplicationCorrection={
                        confirmInternshipApplicationCorrection
                      }
                      getInternshipApplications={getInternshipApplications}
                      respondToPlacementOffer={respondToPlacementOffer}
                      placementRejectionReasons={placementRejectionReasons}
                      getPlacementRejectionLogs={getPlacementRejectionLogs}
                      placementRejectionLogs={placementRejectionLogs}
                      getApplicationPlacements={getApplicationPlacements}
                      placements={
                        applicationPlacements[application?.applicationId] || []
                      }
                    />
                  </div>
                ))
              ) : (
                <NoResults />
              )}
            </div>
          </div>
        </section>
      </div>
      <aside className="col-12 mb-3 col-sm-4 col-md-3 order-first order-sm-last px-1 px-sm-3">
        <ProfileSummary />
      </aside>
      {showDocument && previewDocument && (
        <PreviewPdfUrl
          showDocument={showDocument}
          setShowDocument={() => setShowDocument(false)}
          document={previewDocument}
          isBase64={isBase64}
        />
      )}

      {/* Edit Menu */}
      <Menu
        anchorEl={editMenuAnchor}
        open={Boolean(editMenuAnchor)}
        onClose={handleEditMenuClose}
      >
        <MenuItem onClick={openEditEducation}>
          <SchoolIcon className="mr-2" fontSize="small" />
          Edit Education Info
        </MenuItem>
        <MenuItem onClick={openEditBank}>
          <AccountBalanceIcon className="mr-2" fontSize="small" />
          Edit Bank Details
        </MenuItem>
        <MenuItem onClick={openEditDocuments}>
          <DescriptionIcon className="mr-2" fontSize="small" />
          Update Documents
        </MenuItem>
      </Menu>

      {/* Edit Education Modal */}
      {selectedApplication && (
        <EditEducationModal
          open={showEditEducation}
          onClose={() => {
            setShowEditEducation(false);
            setSelectedApplication(null);
          }}
          application={selectedApplication}
          lookup={lookup}
          getEducationalInstitutions={getEducationalInstitutions}
          getQualifications={getQualifications}
          updateInternshipApplication={updateInternshipApplication}
          getInternshipApplications={getInternshipApplications}
          onEditSuccess={(appId) => {
            setApplicationWithEdit(appId);
            showSuccess(
              "Education information updated successfully. Please confirm your changes.",
            );
          }}
        />
      )}

      {/* Edit Bank Modal */}
      {selectedApplication && (
        <EditBankModal
          open={showEditBank}
          onClose={() => {
            setShowEditBank(false);
            setSelectedApplication(null);
          }}
          application={selectedApplication}
          lookup={lookup}
          updateInternshipApplication={updateInternshipApplication}
          getInternshipApplications={getInternshipApplications}
          onEditSuccess={(appId) => {
            setApplicationWithEdit(appId);
            showSuccess(
              "Education information updated successfully. Please confirm your changes.",
            );
          }}
        />
      )}

      {/* Edit Documents Modal */}
      {selectedApplication && (
        <EditDocumentsModal
          open={showEditDocuments}
          onClose={() => {
            setShowEditDocuments(false);
            setSelectedApplication(null);
          }}
          application={selectedApplication}
          updateInternshipApplication={updateInternshipApplicationDocuments}
          getInternshipApplications={getInternshipApplications}
          onPreview={(docRef, title) => handlePreviewByDocRef(docRef, title)}
          onEditSuccess={(appId) => {
            setApplicationWithEdit(appId);
            showSuccess(
              "Documents updated successfully. Please confirm your changes.",
            );
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({
  user,
  loading,
  internshipApplications,
  lookup,
  placementRejectionReasons,
  placementRejectionLogs,
  applicationPlacements,
}) => ({
  user,
  loading,
  internshipApplications,
  lookup,
  placementRejectionReasons,
  placementRejectionLogs,
  applicationPlacements,
});

export default connect(mapStateToProps, {
  getInternshipApplications,
  updateInternshipApplication,
  updateInternshipApplicationDocuments,
  confirmInternshipApplicationCorrection,
  respondToPlacementOffer,
  getPlacementRejectionReasons,
  getPlacementRejectionLogs,
  getApplicationPlacements,
  getCountries,
  getDegrees,
  getEducationalInstitutions,
  getQualifications,
  getQualificationGrades,
  getBanks,
})(InternshipApplications);

// Edit Education Modal Component
const EditEducationModal = ({
  open,
  onClose,
  application,
  lookup,
  getEducationalInstitutions,
  getQualifications,
  updateInternshipApplication,
  getInternshipApplications,
  onEditSuccess,
}) => {
  const [country, setCountry] = useState(null);
  const [institution, setInstitution] = useState(null);
  const [degree, setDegree] = useState(null);
  const [qualification, setQualification] = useState(null);
  const [qualificationGrade, setQualificationGrade] = useState(null);
  const [graduateDate, setGraduateDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (application?.countryId && lookup?.countries) {
      const foundCountry = lookup.countries.find(
        (c) => c.id === application.countryId,
      );
      if (foundCountry) setCountry(foundCountry);
    }
  }, [application?.countryId, lookup?.countries]);

  useEffect(() => {
    if (application?.degreeId && lookup?.degrees) {
      const foundDegree = lookup.degrees.find(
        (d) => d.id === application.degreeId,
      );
      if (foundDegree) setDegree(foundDegree);
    }
  }, [application?.degreeId, lookup?.degrees]);

  useEffect(() => {
    if (application?.qualificationGradeId && lookup?.qualificationGrades) {
      const foundGrade = lookup.qualificationGrades.find(
        (g) => g.id === application.qualificationGradeId,
      );
      if (foundGrade) setQualificationGrade(foundGrade);
    }
  }, [application?.qualificationGradeId, lookup?.qualificationGrades]);

  useEffect(() => {
    if (application?.graduationDate) {
      try {
        const gradDate = new Date(application.graduationDate);
        if (!isNaN(gradDate.getTime())) setGraduateDate(gradDate);
      } catch {}
    }
  }, [application?.graduationDate]);

  useEffect(() => {
    if (country) getEducationalInstitutions(country?.id);
  }, [country]);

  useEffect(() => {
    if (application?.schoolId && country && lookup.educationalInstitutions) {
      const foundInstitution = lookup.educationalInstitutions.find(
        (inst) => inst.id === application.schoolId,
      );
      if (foundInstitution) setInstitution(foundInstitution);
    }
  }, [application?.schoolId, country, lookup.educationalInstitutions]);

  useEffect(() => {
    if (degree) getQualifications(degree?.id);
  }, [degree]);

  useEffect(() => {
    if (application?.qualificationId && degree && lookup.qualifications) {
      const foundQualification = lookup.qualifications.find(
        (q) =>
          q.id === application.qualificationId ||
          q.id === String(application.qualificationId),
      );
      if (foundQualification) setQualification(foundQualification);
    }
  }, [application?.qualificationId, degree, lookup.qualifications]);

  const filterDegrees = () =>
    lookup.degrees?.filter(({ id }) => id !== 9 && id !== 10) || [];

  const handleSubmit = async () => {
    if (
      !country ||
      !institution ||
      !degree ||
      !qualification ||
      !qualificationGrade ||
      !graduateDate
    ) {
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("schoolId", institution.id);
    formData.append(
      "graduationYear",
      graduateDate ? new Date(graduateDate).getFullYear() : "",
    );
    formData.append("graduateDate", graduateDate);
    formData.append("degreeId", degree.id);
    formData.append("qualificationId", qualification.id);
    formData.append("qualificationGradeId", qualificationGrade.id);

    await updateInternshipApplication(
      application.applicationId,
      formData,
      () => {
        // getInternshipApplications(0, () => {});
        if (onEditSuccess) {
          onEditSuccess(application.applicationId);
        }
        onClose();
      },
    );
    setLoading(false);
  };

  return (
    <DialogModel
      isOpen={open}
      handleClose={onClose}
      title="Edit Education Information"
      maxWidth="md"
      isFullWidth
      footerContent={
        <div className="d-flex justify-content-end">
          <Button onClick={onClose} className="mr-2">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={
              loading ||
              !country ||
              !institution ||
              !degree ||
              !qualification ||
              !qualificationGrade ||
              !graduateDate
            }
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      }
    >
      <div className="row">
        <div className="form-group col-12 col-md-6 mb-3">
          <Autocomplete
            size="small"
            value={country}
            options={lookup.countries || []}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, country) => {
              setCountry(country || null);
              setInstitution(null);
            }}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => <TextField {...params} label="Country" />}
          />
        </div>
        <div className="form-group col-12 col-md-6 mb-3">
          <Autocomplete
            size="small"
            value={institution}
            options={lookup.educationalInstitutions || []}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, institute) => setInstitution(institute || null)}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => (
              <TextField {...params} label="Institution" />
            )}
          />
        </div>
        <div className="form-group col-12 col-md-6 mb-3">
          <Autocomplete
            size="small"
            value={degree}
            options={filterDegrees()}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, degree) => {
              setDegree(degree || null);
              setQualification(null);
            }}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => <TextField {...params} label="Degree" />}
          />
        </div>
        <div className="form-group col-12 col-md-6 mb-3">
          <Autocomplete
            size="small"
            value={qualification}
            options={lookup.qualifications || []}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, qualification) =>
              setQualification(qualification || null)
            }
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => (
              <TextField {...params} label="Qualification" />
            )}
          />
        </div>
        <div className="form-group col-12 col-md-6 mb-3">
          <Autocomplete
            size="small"
            value={qualificationGrade}
            options={lookup.qualificationGrades || []}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, grade) => setQualificationGrade(grade || null)}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => (
              <TextField {...params} label="Qualification Grade" />
            )}
          />
        </div>
        <div className="form-group col-12 col-md-6 mb-3">
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Graduation Date"
              inputFormat="yyyy-MM-dd"
              value={graduateDate}
              onChange={(newValue) => setGraduateDate(newValue)}
              renderInput={(params) => (
                <TextField
                  onKeyDown={(e) => e.preventDefault()}
                  {...params}
                  size="small"
                />
              )}
            />
          </LocalizationProvider>
        </div>
      </div>
    </DialogModel>
  );
};

// Edit Bank Modal Component
const EditBankModal = ({
  open,
  onClose,
  application,
  lookup,
  updateInternshipApplication,
  getInternshipApplications,
}) => {
  const [bank, setBank] = useState(null);
  const [accountNumber, setAccountNumber] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (application && lookup?.banks) {
      if (application.bankId) {
        const foundBank = lookup.banks.find(
          (b) =>
            b.id === application.bankId || b.id === String(application.bankId),
        );
        if (foundBank) setBank(foundBank);
      }
      if (application.accountNumber) {
        setAccountNumber(application.accountNumber);
      }
    }
  }, [application, lookup]);

  const handleSubmit = async () => {
    if (!bank || !accountNumber) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("bankId", bank.id);
    formData.append("accountNumber", accountNumber);

    await updateInternshipApplication(
      application.applicationId,
      formData,
      () => {
        // getInternshipApplications(0, () => {});
        onClose();
      },
    );
    setLoading(false);
  };

  return (
    <DialogModel
      isOpen={open}
      handleClose={onClose}
      title="Edit Bank Details"
      maxWidth="sm"
      isFullWidth
      footerContent={
        <div className="d-flex justify-content-end">
          <Button onClick={onClose} className="mr-2">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={loading || !bank || !accountNumber}
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </div>
      }
    >
      <div className="row">
        <div className="form-group col-12 mb-3">
          <Autocomplete
            size="small"
            value={bank}
            options={lookup.banks || []}
            isOptionEqualToValue={(option, value) => {
              if (!option || !value) return option === value;
              return option.id === value.id;
            }}
            onChange={(event, bank) => setBank(bank || null)}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => <TextField {...params} label="Bank" />}
          />
        </div>
        <div className="form-group col-12 mb-3">
          <TextField
            size="small"
            fullWidth
            label="Account Number"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
        </div>
      </div>
    </DialogModel>
  );
};

// Edit Documents Modal Component
const EditDocumentsModal = ({
  open,
  onClose,
  application,
  updateInternshipApplication,
  getInternshipApplications,
  onPreview,
  onEditSuccess,
}) => {
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [loading, setLoading] = useState(false);
  const degreeFileInputRef = React.useRef(null);
  const cvFileInputRef = React.useRef(null);

  // Doc reference to preview for each section: only shown while no new
  // file has been picked to replace what's currently attached.
  const degreePreviewDocRef = !file ? application?.degreeReferenceDocId : null;
  const cvPreviewDocRef = !file2 ? application?.cvReferenceDocId : null;

  const handleSubmit = async () => {
    if (!(file && file[0]) && !(file2 && file2[0])) {
      showError("Please select a file to upload");
      return;
    }

    setLoading(true);
    const formData = new FormData();

    if (file?.[0]) formData.append("degreeFile", file[0]);
    if (file2?.[0]) formData.append("cvFile", file2[0]);

    await updateInternshipApplication(
      application.applicationId,
      formData,
      () => {
        // getInternshipApplications(0, () => {});
        if (onEditSuccess) {
          onEditSuccess(application.applicationId);
        }
        onClose();
      },
    );

    setLoading(false);
  };

  return (
    <>
      <DialogModel
        isOpen={open}
        handleClose={onClose}
        title="Update Documents"
        maxWidth="md"
        isFullWidth
        footerContent={
          <div className="d-flex justify-content-end">
            <Button onClick={onClose} className="mr-2">
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        }
      >
        <div className="row">
          <div className="form-group col-12 mb-4">
            <strong className="d-block mb-1">Qualification document</strong>
            <div className="text-muted small mb-2">
              <div>
                <strong>Degree:</strong> {application?.degreeName || "-"}
              </div>
              <div>
                <strong>Qualification:</strong>{" "}
                {application?.qualificationName || "-"}
              </div>
              <div>
                <strong>School:</strong> {application?.schoolName || "-"}
              </div>
              <div>
                <strong>Graduation:</strong>{" "}
                {formatDate(application?.graduationDate)}
              </div>
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="file"
                accept="application/pdf"
                ref={degreeFileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  const selected = e.target.files?.[0];
                  setFile(selected ? [selected] : null);
                  e.target.value = null;
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={() => degreeFileInputRef.current?.click()}
                className="mr-2 mb-1"
              >
                {file ? "Change degree" : "Attach degree"}
              </Button>
              {degreePreviewDocRef && (
                <Button
                  variant="text"
                  size="small"
                  className="mr-2 mb-1"
                  onClick={() =>
                    onPreview?.(degreePreviewDocRef, "Qualification document")
                  }
                >
                  Preview
                </Button>
              )}
              <span className="text-truncate">
                {file
                  ? file[0].name
                  : application?.degreeReferenceDocId
                    ? "Current degree document"
                    : "No file selected"}
              </span>
            </div>
          </div>
          <div className="form-group col-12 mb-3">
            <strong className="d-block mb-1">Curriculum Vitae</strong>
            <div className="d-flex align-items-center flex-wrap">
              <input
                type="file"
                accept="application/pdf"
                ref={cvFileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  const selected = e.target.files?.[0];
                  setFile2(selected ? [selected] : null);
                  e.target.value = null;
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={() => cvFileInputRef.current?.click()}
                className="mr-2 mb-1"
              >
                {file2 ? "Change CV" : "Attach CV"}
              </Button>
              {cvPreviewDocRef && (
                <Button
                  variant="text"
                  size="small"
                  className="mr-2 mb-1"
                  onClick={() =>
                    onPreview?.(cvPreviewDocRef, "Curriculum Vitae")
                  }
                >
                  Preview
                </Button>
              )}
              <span className="text-truncate">
                {file2
                  ? file2[0].name
                  : application?.cvReferenceDocId
                    ? "Current CV document"
                    : "No CV selected"}
              </span>
            </div>
          </div>
        </div>
      </DialogModel>
    </>
  );
};

// Custom card to display internship application (summary + expandable details)
const statusMap = {
  1: { label: "Received", color: "primary" },
  2: { label: "Approved", color: "success" },
  3: { label: "Rejected", color: "error" },
  4: { label: "Correction Re-submitted", color: "warning" },
};

function formatDate(dateStr) {
  if (!dateStr) return "-";
  try {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toISOString().slice(0, 10);
  } catch {
    return "-";
  }
}

function formatDateTime(dateStr) {
  if (!dateStr) return "—";
  try {
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleString("en-GB", {
      timeZone: "UTC",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

function getRemainingDays(toDate) {
  if (!toDate) return null;
  const end = new Date(toDate);
  if (Number.isNaN(end.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);
  return Math.round((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
}

const InternshipCard = ({
  application,
  onEdit,
  onPreview,
  defaultExpanded = false,
  showConfirmPopover = false,
  setApplicationWithEdit,
  confirmInternshipApplicationCorrection,
  getInternshipApplications,
  respondToPlacementOffer,
  placementRejectionReasons = [],
  getPlacementRejectionLogs,
  placementRejectionLogs = [],
  getApplicationPlacements,
  placements = [],
}) => {
  const mustBeOpen =
    placements.some((p) => [2, 3, 16].includes(p?.statusId)) ||
    application?.sentToApplicantForCorrection === true ||
    application?.sentToApplicantForCorrection === 1;

  const [expanded, setExpanded] = React.useState(defaultExpanded || mustBeOpen);

  const toggleExpanded = () => {
    if (!mustBeOpen) setExpanded((v) => !v);
  };
  const [showRejectionDialog, setShowRejectionDialog] = React.useState(false);
  const [showConfirmCorrectionDialog, setShowConfirmCorrectionDialog] =
    React.useState(false);
  const [agreedToCorrections, setAgreedToCorrections] = React.useState(false);
  const [confirming, setConfirming] = React.useState(false);
  const confirmButtonRef = React.useRef(null);

  useEffect(() => {
    if (application?.applicationId) {
      getApplicationPlacements?.(application.applicationId);
    }
  }, [application?.applicationId]);

  // Auto-expand once placements load and one of them needs a response
  useEffect(() => {
    if (mustBeOpen) setExpanded(true);
  }, [mustBeOpen]);

  // Placement offer dialog state
  const [showPlacementDialog, setShowPlacementDialog] = React.useState(false);
  const [placementDialogMode, setPlacementDialogMode] =
    React.useState("accept");
  const [placementDialogContext, setPlacementDialogContext] =
    React.useState("offer");
  const [agreementChecked, setAgreementChecked] = React.useState(false);
  const [agreementMessage, setAgreementMessage] = React.useState("");
  const [rejectMessage, setRejectMessage] = React.useState("");
  const [rejectReasonId, setRejectReasonId] = React.useState(null);
  const [submittingOffer, setSubmittingOffer] = React.useState(false);

  const [showLogsDialog, setShowLogsDialog] = React.useState(false);
  const [loadingLogs, setLoadingLogs] = React.useState(false);
  // console.log(application)
  const handleViewRejectionLogs = async () => {
    setLoadingLogs(true);
    await getPlacementRejectionLogs(application.waitingListId);
    setLoadingLogs(false);
    setShowLogsDialog(true);
  };

  const getPlacementStatusStyle = (statusId) => {
    const map = {
      1: { bg: "#dbeafe", border: "primary", badge: "primary" },
      2: { bg: "#dbeafe", border: "primary", badge: "primary" },
      3: { bg: "#e0f2fe", border: "info", badge: "info" },
      4: { bg: "#c9ffd6", border: "success", badge: "success" },
      5: { bg: "#f2e1df", border: "danger", badge: "danger" },
      6: { bg: "#f3f4f6", border: "secondary", badge: "secondary" },
      7: { bg: "#f3f4f6", border: "secondary", badge: "secondary" },
      8: { bg: "#e0f2fe", border: "info", badge: "info" },
      9: { bg: "#c9ffd6", border: "success", badge: "success" },
      10: { bg: "#f2e1df", border: "danger", badge: "danger" },
      11: { bg: "#f3f4f6", border: "secondary", badge: "secondary" },
      12: { bg: "#fef9c3", border: "warning", badge: "warning" },
      13: { bg: "#c9ffd6", border: "success", badge: "success" },
      14: { bg: "#f2e1df", border: "danger", badge: "danger" },
      15: { bg: "#fef9c3", border: "warning", badge: "warning" },
    };
    return (
      map[statusId] || {
        bg: "#f3f4f6",
        border: "secondary",
        badge: "secondary",
      }
    );
  };

  const [activePlacement, setActivePlacement] = React.useState(null);

  const openPlacementDialog = (mode, placement, context = "offer") => {
    setActivePlacement(placement);
    setPlacementDialogMode(mode);
    setPlacementDialogContext(context);
    setAgreementChecked(false);
    setAgreementMessage("");
    setRejectMessage("");
    setRejectReasonId(null);
    setShowPlacementDialog(true);
  };
  const s = statusMap[application?.statusId] || {
    label: application?.applicationStatus || "Unknown",
    color: "default",
  };

  const isRejected = application?.statusId === 3;
  const canEdit =
    isRejected &&
    (application?.sentToApplicantForCorrection === true ||
      application?.sentToApplicantForCorrection === 1);

  const handleEditEducation = (e) => {
    e.stopPropagation();
    onEdit?.(e, application, "education");
  };

  const handleEditBank = (e) => {
    e.stopPropagation();
    onEdit?.(e, application, "bank");
  };

  const handleEditDocuments = (e) => {
    e.stopPropagation();
    onEdit?.(e, application, "documents");
  };
  // console.log(placementRejectionLogs)
  return (
    <section className="card elevated rounded border bg-white">
      <div className="card-body">
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
          <div className="mb-2 mb-md-0">
            <Typography variant="subtitle1" component="h3" className="mb-1">
              {application?.qualificationName || "Internship application"}
            </Typography>
            <div className="text-muted small">
              <strong className="mr-2">
                #{application?.applicationId || "-"}
              </strong>
              <span className="mr-2">
                Institution: {application?.schoolName || "-"}
              </span>
              <span className="mr-2">
                Degree: {application?.degreeName || "-"}
              </span>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {canEdit && (
              <IconButton
                size="small"
                className="mr-2"
                onClick={() => setShowRejectionDialog(true)}
                aria-label="View rejection reason"
                sx={{
                  color: "error.main",
                  animation: "pulse 2s infinite",
                  "@keyframes pulse": {
                    "0%, 100%": {
                      opacity: 1,
                      transform: "scale(1)",
                    },
                    "50%": {
                      opacity: 0.7,
                      transform: "scale(1.1)",
                    },
                  },
                }}
              >
                <NotificationImportantIcon />
              </IconButton>
            )}

            <Chip
              label={s.label}
              color={s.color}
              variant={s.color === "default" ? "outlined" : "filled"}
              className="mr-2"
              size="small"
            />
            {!mustBeOpen && (
              <Button
                variant="text"
                size="small"
                className="mr-2"
                onClick={toggleExpanded}
                aria-expanded={expanded}
                aria-controls={`app-details-${application?.applicationId || ""}`}
              >
                {expanded ? "Hide details" : "View details"}
              </Button>
            )}
          </div>
        </div>

        <Collapse in={expanded}>
          <Divider className="my-2" />
          <Box
            id={`app-details-${application?.applicationId || ""}`}
            className="mt-3"
          >
            {isRejected && (
              <div className="row">
                <div className="col-12 col-lg-12 mb-3">
                  <Alert
                    severity="warning"
                    className="w-100 border border-danger"
                  >
                    <AlertTitle className="w-100">
                      Rejection comments:
                    </AlertTitle>
                    <div className="w-100">
                      {application?.applicationRejectionReason ||
                        "No rejection reason provided."}
                    </div>
                  </Alert>
                </div>
                {canEdit && (
                  <div className="col-12 col-lg-12 mb-3 text-right mt-0">
                    <Button
                      ref={confirmButtonRef}
                      variant="contained"
                      startIcon={<CheckCircleIcon />}
                      size="medium"
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: "8px",
                        px: 3,
                        py: 1,
                        backgroundColor: "#1976d2",
                        color: "#ffffff",
                        boxShadow: 2,
                        "&:hover": {
                          backgroundColor: "#1976d2",
                          boxShadow: 4,
                        },
                      }}
                      onClick={() => {
                        setShowConfirmCorrectionDialog(true);
                      }}
                    >
                      Confirm Correction
                    </Button>
                    {showConfirmPopover && (
                      <Popover
                        open={true}
                        anchorEl={confirmButtonRef.current}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                        onClose={() => {}}
                        disableRestoreFocus
                        PaperProps={{
                          sx: {
                            mt: 1,
                            overflow: "visible",
                            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                            bgcolor: "#000000",
                            color: "#ffffff",
                            "&:before": {
                              content: '""',
                              display: "block",
                              position: "absolute",
                              top: 0,
                              left: "50%",
                              transform: "translate(-50%, -50%) rotate(45deg)",
                              width: 12,
                              height: 12,
                              bgcolor: "#000000",
                              zIndex: 0,
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            p: 2,
                            maxWidth: 250,
                            position: "relative",
                            zIndex: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ color: "#ffffff" }}>
                            Please confirm your corrections to complete the
                            update.
                          </Typography>
                        </Box>
                      </Popover>
                    )}
                  </div>
                )}
              </div>
            )}
            {/* Placement card(s) — shown for every placement that exists on this application */}
            {placements.length > 0 && (
              <div className="row mb-2">
                <div className="col-12">
                  {placements.map((placement, index) => {
                    const style = getPlacementStatusStyle(placement.statusId);
                    const canRespond = [2, 3].includes(placement.statusId);
                    const canRespondInterview = placement.statusId === 16;
                    const contractRemainingDays = getRemainingDays(
                      placement.contractToDate,
                    );

                    return (
                      <Accordion
                        key={placement.placementId || index}
                        defaultExpanded={index === 0}
                        className={`border rounded mb-2 border-${style.border}`}
                        sx={{
                          backgroundColor: style.bg,
                          "&:before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          className="d-flex align-items-center"
                        >
                          <div className="d-flex align-items-center justify-content-between w-100 mr-2">
                            <div className="d-flex align-items-center">
                              <BusinessIcon
                                fontSize="small"
                                className="mr-2 text-primary"
                              />
                              <strong style={{ fontSize: "1rem" }}>
                                Placement Offer
                              </strong>
                            </div>
                            <span
                              className={`badge badge-pill px-3 py-1 text-${style.badge}`}
                              style={{
                                fontSize: "0.8rem",
                                border: "1px solid currentColor",
                              }}
                            >
                              {placement.status}
                            </span>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails>
                          {/* Details grid */}
                          <div className="row mx-0 mb-2">
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <BusinessIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Company
                              </div>
                              <div className="font-weight-bold">
                                {placement.company || "-"}
                              </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <LocationOnIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Location
                              </div>
                              <div className="font-weight-bold">
                                {[placement.district, placement.province]
                                  .filter(Boolean)
                                  .join(", ") || "-"}
                              </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <SchoolIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Qualification
                              </div>
                              <div className="font-weight-bold">
                                {placement.qualification || "-"}
                              </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <SupervisorAccountIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Supervisor
                              </div>
                              <div className="font-weight-bold">
                                {placement.supervisor || "-"}
                              </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <AttachMoneyIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Monthly Compensation
                              </div>
                              <div className="font-weight-bold">
                                {placement.monthlyCompensation != null
                                  ? `${Number(placement.monthlyCompensation).toLocaleString()} RWF`
                                  : "-"}
                              </div>
                            </div>
                            <div className="col-12 mb-2 px-2">
                              <div className="d-flex align-items-center text-muted small mb-2">
                                <AssignmentIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Responsibilities
                              </div>
                              <div
                                style={{
                                  lineHeight: "1.7",
                                  fontSize: "0.92rem",
                                  whiteSpace: "pre-wrap",
                                  color: "#374151",
                                  backgroundColor: "rgba(255,255,255,0.55)",
                                  borderRadius: "6px",
                                  padding: "10px 14px",
                                  border: "1px solid rgba(0,0,0,0.07)",
                                }}
                              >
                                {placement.responsibilities || "-"}
                              </div>
                            </div>
                            <div className="col-12 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <EventIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Last Updated
                              </div>
                              <div className="font-weight-bold">
                                {formatDateTime(placement.createdOn)}
                              </div>
                            </div>
                            {placement.comments && (
                              <div className="col-12 mb-2 px-2">
                                <div className="d-flex align-items-center text-muted small mb-2">
                                  <ChatBubbleOutlineIcon
                                    fontSize="inherit"
                                    className="mr-1"
                                  />
                                  Last Comment
                                </div>
                                <div
                                  style={{
                                    lineHeight: "1.7",
                                    fontSize: "0.92rem",
                                    whiteSpace: "pre-wrap",
                                    color: "#374151",
                                    backgroundColor: "rgba(255,255,255,0.55)",
                                    borderRadius: "6px",
                                    padding: "10px 14px",
                                    border: "1px solid rgba(0,0,0,0.07)",
                                  }}
                                >
                                  {placement.comments}
                                </div>
                              </div>
                            )}
                          </div>

                          {/* Contract card — shown once a signed contract is on file */}
                          {placement.contractDocReferenceId && (
                            <div
                              className="mb-3 p-3 rounded border"
                              style={{
                                backgroundColor: "rgba(255,255,255,0.6)",
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                                <div className="d-flex align-items-center">
                                  <DescriptionIcon
                                    fontSize="small"
                                    className="mr-2 text-primary"
                                  />
                                  <strong>Contract</strong>
                                </div>
                                <Button
                                  variant="text"
                                  size="small"
                                  startIcon={
                                    <PictureAsPdfIcon fontSize="small" />
                                  }
                                  onClick={() =>
                                    onPreview?.(
                                      placement.contractDocReferenceId,
                                      "Contract document",
                                    )
                                  }
                                >
                                  View Contract
                                </Button>
                              </div>
                              <div className="row mx-0">
                                <div className="col-6 col-md-4 mb-2 px-2">
                                  <div className="d-flex align-items-center text-muted small mb-1">
                                    <CalendarTodayIcon
                                      fontSize="inherit"
                                      className="mr-1"
                                    />
                                    Start Date
                                  </div>
                                  <div className="font-weight-bold">
                                    {formatDate(placement.contractFromDate)}
                                  </div>
                                </div>
                                <div className="col-6 col-md-4 mb-2 px-2">
                                  <div className="d-flex align-items-center text-muted small mb-1">
                                    <EventBusyIcon
                                      fontSize="inherit"
                                      className="mr-1"
                                    />
                                    End Date
                                  </div>
                                  <div className="font-weight-bold">
                                    {formatDate(placement.contractToDate)}
                                  </div>
                                </div>
                                <div className="col-6 col-md-4 mb-2 px-2">
                                  <div className="d-flex align-items-center text-muted small mb-1">
                                    <PendingActionsIcon
                                      fontSize="inherit"
                                      className="mr-1"
                                    />
                                    Remaining
                                  </div>
                                  <div
                                    className="font-weight-bold"
                                    style={{
                                      color:
                                        contractRemainingDays == null
                                          ? "inherit"
                                          : contractRemainingDays < 0
                                            ? "#6c757d"
                                            : contractRemainingDays <= 7
                                              ? "#dc3545"
                                              : "inherit",
                                    }}
                                  >
                                    {contractRemainingDays == null
                                      ? "-"
                                      : contractRemainingDays > 0
                                        ? `${contractRemainingDays} day${contractRemainingDays !== 1 ? "s" : ""} left`
                                        : contractRemainingDays === 0
                                          ? "Ends today"
                                          : "Contract ended"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Accept / Reject actions — only for Offer Sent / Offer Viewed */}
                          {canRespond && (
                            <div
                              className="d-flex align-items-center pt-2"
                              style={{
                                borderTop: "1px solid rgba(0,0,0,0.08)",
                              }}
                            >
                              <span className="text-muted small mr-3">
                                Respond to offer:
                              </span>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<ThumbUpIcon fontSize="small" />}
                                onClick={() =>
                                  openPlacementDialog("accept", placement)
                                }
                                style={{
                                  backgroundColor: "#16a34a",
                                  color: "#fff",
                                  marginRight: "8px",
                                  textTransform: "none",
                                }}
                              >
                                Accept
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ThumbDownIcon fontSize="small" />}
                                onClick={() =>
                                  openPlacementDialog("reject", placement)
                                }
                                style={{
                                  borderColor: "#dc2626",
                                  color: "#dc2626",
                                  textTransform: "none",
                                }}
                              >
                                Reject
                              </Button>
                            </div>
                          )}

                          {/* Accept / Reject interview invitation actions */}
                          {canRespondInterview && (
                            <div
                              className="d-flex align-items-center pt-2"
                              style={{
                                borderTop: "1px solid rgba(0,0,0,0.08)",
                              }}
                            >
                              <span className="text-muted small mr-3">
                                Respond to interview invitation:
                              </span>
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<ThumbUpIcon fontSize="small" />}
                                onClick={() =>
                                  openPlacementDialog(
                                    "accept",
                                    placement,
                                    "interview",
                                  )
                                }
                                style={{
                                  backgroundColor: "#16a34a",
                                  color: "#fff",
                                  marginRight: "8px",
                                  textTransform: "none",
                                }}
                              >
                                Accept to join interview
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ThumbDownIcon fontSize="small" />}
                                onClick={() =>
                                  openPlacementDialog(
                                    "reject",
                                    placement,
                                    "interview",
                                  )
                                }
                                style={{
                                  borderColor: "#dc2626",
                                  color: "#dc2626",
                                  textTransform: "none",
                                }}
                              >
                                Reject to join interview
                              </Button>
                            </div>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="row">
              <div className="col-12 col-lg-12 mb-3">
                {application.statusId === 1 &&
                !application.waitingListStatusId ? (
                  <>
                    <Box
                      className="border rounded border-info p-3 h-100 position-relative"
                      style={{ backgroundColor: "#f1f1f1" }}
                    >
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center text-primary">
                          <PendingActionsIcon
                            fontSize="small"
                            className="mr-1 text-primary"
                          />
                          <strong>
                            Your internship application is still pending for
                            approval.
                          </strong>
                        </div>
                      </div>
                    </Box>
                  </>
                ) : (
                  <>
                    {application.statusId === 2 && (
                      <Box
                        className={`border rounded p-3 h-100 position-relative border-${
                          application.waitingListStatusId === 1
                            ? "primary"
                            : application.waitingListStatusId === 2
                              ? "warning"
                              : application.waitingListStatusId === 3
                                ? "success"
                                : application.waitingListStatusId === 4
                                  ? "danger"
                                  : "secondary"
                        }`}
                        style={{
                          backgroundColor:
                            application.waitingListStatusId === 1
                              ? "#dbeafe"
                              : application.waitingListStatusId === 2
                                ? "#fef9c3"
                                : application.waitingListStatusId === 3
                                  ? "#c9ffd6"
                                  : application.waitingListStatusId === 4
                                    ? "#f2e1df"
                                    : "#f3f4f6",
                        }}
                      >
                        {/* Header */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <EventIcon
                              fontSize="small"
                              className="mr-1 text-primary"
                            />
                            <strong>Waiting List</strong>
                          </div>
                          <span
                            className={`badge badge-pill px-3 py-1 text-${
                              application.waitingListStatusId === 1
                                ? "primary"
                                : application.waitingListStatusId === 2
                                  ? "warning"
                                  : application.waitingListStatusId === 3
                                    ? "success"
                                    : application.waitingListStatusId === 4
                                      ? "danger"
                                      : "secondary"
                            }`}
                            style={{
                              fontSize: "0.8rem",
                              border: "1px solid currentColor",
                            }}
                          >
                            {application?.waitingListStatusName}
                          </span>
                        </div>

                        {/* Stats grid */}
                        <div className="row mx-0">
                          <div className="col-6 col-md-4 mb-3 px-2">
                            <div className="d-flex align-items-center text-muted small mb-1">
                              <GroupIcon fontSize="inherit" className="mr-1" />
                              Total on List
                            </div>
                            <div
                              className="font-weight-bold"
                              style={{ fontSize: "1.1rem" }}
                            >
                              {application?.totalWaitingListIntern || "-"}
                            </div>
                          </div>
                          <div className="col-6 col-md-4 mb-3 px-2">
                            <div className="d-flex align-items-center text-muted small mb-1">
                              <CalendarTodayIcon
                                fontSize="inherit"
                                className="mr-1"
                              />
                              Start Date
                            </div>
                            <div className="font-weight-bold">
                              {formatDate(application?.waitingListStartDate) ||
                                "-"}
                            </div>
                          </div>
                          <div className="col-6 col-md-4 mb-3 px-2">
                            <div className="d-flex align-items-center text-muted small mb-1">
                              <EventBusyIcon
                                fontSize="inherit"
                                className="mr-1"
                              />
                              Expiration Date
                            </div>
                            <div className="font-weight-bold">
                              {formatDate(
                                application?.waitingListExpiresDate,
                              ) || "-"}
                            </div>
                          </div>
                          {application?.offerRejectionCount != null && (
                            <div className="col-6 col-md-4 mb-3 px-2">
                              <div className="d-flex align-items-center text-muted small mb-1">
                                <ThumbDownIcon
                                  fontSize="inherit"
                                  className="mr-1"
                                />
                                Offer Rejections
                              </div>
                              {(() => {
                                const used = application.offerRejectionCount;
                                const remaining = 3 - used;
                                return (
                                  <div>
                                    <span
                                      className="font-weight-bold"
                                      style={{
                                        fontSize: "1.1rem",
                                        color:
                                          remaining === 0
                                            ? "#dc3545"
                                            : remaining === 1
                                              ? "#fd7e14"
                                              : "inherit",
                                      }}
                                    >
                                      {used} / 3
                                    </span>
                                    <div
                                      className="small"
                                      style={{
                                        color:
                                          remaining === 0
                                            ? "#dc3545"
                                            : remaining === 1
                                              ? "#fd7e14"
                                              : "#6c757d",
                                      }}
                                    >
                                      {remaining === 0
                                        ? "No chances left"
                                        : `${remaining} chance${remaining !== 1 ? "s" : ""} remaining`}
                                    </div>
                                    {(application?.placementRejectedNumber ??
                                      0) > 0 && (
                                      <Button
                                        size="small"
                                        variant="text"
                                        disabled={loadingLogs}
                                        onClick={handleViewRejectionLogs}
                                        sx={{
                                          fontSize: "0.72rem",
                                          p: 0,
                                          minWidth: 0,
                                          textTransform: "none",
                                          mt: 0.5,
                                        }}
                                      >
                                        {loadingLogs
                                          ? "Loading…"
                                          : "View rejection history"}
                                      </Button>
                                    )}
                                  </div>
                                );
                              })()}
                            </div>
                          )}
                        </div>
                      </Box>
                    )}
                  </>
                )}
              </div>
              <div className="col-12 col-lg-6 mb-3">
                <Box className="border rounded p-3 h-100 bg-white">
                  <div className="d-flex align-items-center mb-2">
                    <PersonIcon
                      fontSize="small"
                      className="mr-1 text-primary"
                    />
                    <strong>Personal info</strong>
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Name:</strong>{" "}
                    {[application?.firstName, application?.lastName]
                      .filter(Boolean)
                      .join(" ") || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Gender:</strong> {application?.gender || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Phone:</strong> {application?.phoneNumber || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Email:</strong> {application?.email || "-"}
                  </div>
                </Box>
              </div>
              <div className="col-12 col-lg-6 mb-3">
                <Box className="border rounded p-3 h-100 bg-white position-relative">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <EventIcon
                        fontSize="small"
                        className="mr-1 text-primary"
                      />
                      <strong>Other details</strong>
                    </div>

                    <IconButton
                      size="small"
                      onClick={handleEditBank}
                      aria-label="Edit bank details"
                      sx={{ color: "primary.main", padding: "4px" }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </div>
                  <div className="text-muted mb-1">
                    {/* <AccountBalanceIcon fontSize="small" className="mr-1 text-primary" /> */}
                    <strong>Bank:</strong> {application?.bankName || "-"}
                  </div>
                  <div className="text-muted mb-2">
                    <strong>Account:</strong>{" "}
                    {application?.accountNumber || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Application date:</strong>{" "}
                    {formatDate(application?.applicationDate)}
                  </div>
                  <div className="text-muted mb-3">
                    <strong>Status:</strong> {s.label}
                  </div>
                </Box>
              </div>

              <div className="col-12 col-lg-6 mb-3">
                <Box className="border rounded p-3 h-100 bg-white position-relative">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <SchoolIcon
                        fontSize="small"
                        className="mr-1 text-primary"
                      />
                      <strong>Education info</strong>
                    </div>
                    {canEdit && (
                      <IconButton
                        size="small"
                        onClick={handleEditEducation}
                        aria-label="Edit education info"
                        sx={{ color: "primary.main", padding: "4px" }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Degree:</strong> {application?.degreeName || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Qualification:</strong>{" "}
                    {application?.qualificationName || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Grade:</strong>{" "}
                    {application?.qualificationGrade || "-"}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>Graduation:</strong>{" "}
                    {formatDate(application?.graduationDate)}
                  </div>
                  <div className="text-muted mb-1">
                    <strong>School:</strong> {application?.schoolName || "-"}
                  </div>
                </Box>
              </div>
              <div className="col-12 col-lg-6 mb-3">
                <Box className="border rounded p-3 h-100 bg-white position-relative">
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center">
                      <DescriptionIcon
                        fontSize="small"
                        className="mr-1 text-primary"
                      />
                      <strong>Documents</strong>
                    </div>
                    {canEdit && (
                      <IconButton
                        size="small"
                        onClick={handleEditDocuments}
                        aria-label="Edit documents"
                        sx={{ color: "primary.main", padding: "4px" }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    )}
                  </div>
                  <div className="text-muted d-flex align-items-center mb-2">
                    <PictureAsPdfIcon
                      fontSize="small"
                      className="mr-2 text-danger"
                    />
                    <div>
                      <div>Qualification Document</div>
                      {application?.degreeReferenceDocId ? (
                        <Button
                          variant="text"
                          size="small"
                          className="px-0"
                          onClick={() =>
                            onPreview?.(
                              application.degreeReferenceDocId,
                              application.qualificationName ||
                                "Degree document",
                            )
                          }
                        >
                          Preview
                        </Button>
                      ) : (
                        <span className="text-muted">Not provided</span>
                      )}
                    </div>
                  </div>
                  <div className="text-muted d-flex align-items-center">
                    <PictureAsPdfIcon
                      fontSize="small"
                      className="mr-2 text-danger"
                    />
                    <div>
                      <div>Curriculum Vitae</div>
                      {application?.cvReferenceDocId ? (
                        <Button
                          variant="text"
                          size="small"
                          className="px-0"
                          onClick={() =>
                            onPreview?.(
                              application.cvReferenceDocId,
                              "Curriculum Vitae",
                            )
                          }
                        >
                          Preview
                        </Button>
                      ) : (
                        <span className="text-muted">Not provided</span>
                      )}
                    </div>
                  </div>
                </Box>
              </div>
            </div>
          </Box>
        </Collapse>
      </div>
      {/* Placement offer accept / reject dialog */}
      <Dialog
        open={showPlacementDialog}
        onClose={() => !submittingOffer && setShowPlacementDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className="d-flex align-items-center">
            {placementDialogMode === "accept" ? (
              <ThumbUpIcon className="mr-2" sx={{ color: "success.main" }} />
            ) : (
              <ThumbDownIcon className="mr-2" sx={{ color: "error.main" }} />
            )}
            {placementDialogMode === "accept"
              ? placementDialogContext === "interview"
                ? "Accept Interview Invitation"
                : "Accept Placement Offer"
              : placementDialogContext === "interview"
                ? "Reject Interview Invitation"
                : "Reject Placement Offer"}
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {placementDialogMode === "accept" ? (
            <>
              <Typography variant="body2" className="mb-3 text-muted">
                {placementDialogContext === "interview" ? (
                  <>
                    By accepting, you confirm your availability to join the
                    interview for the placement offer from{" "}
                    <strong>{activePlacement?.company}</strong>.
                  </>
                ) : (
                  <>
                    By accepting this offer from{" "}
                    <strong>{activePlacement?.company}</strong>, you confirm
                    your availability and interest in the placement.
                  </>
                )}
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agreementChecked}
                    onChange={(e) => setAgreementChecked(e.target.checked)}
                    color="success"
                  />
                }
                label={
                  <span style={{ fontSize: "0.9rem" }}>
                    {placementDialogContext === "interview"
                      ? "I agree to attend the scheduled interview."
                      : "I agree to the placement terms and confirm I am available to start as scheduled."}
                  </span>
                }
                className="mb-3 d-block"
              />
              <TextField
                label="Additional message (optional)"
                multiline
                rows={3}
                fullWidth
                variant="outlined"
                size="small"
                inputProps={{ maxLength: 500 }}
                helperText={`${agreementMessage.length}/500`}
                value={agreementMessage}
                onChange={(e) => setAgreementMessage(e.target.value)}
                placeholder={
                  placementDialogContext === "interview"
                    ? "Any notes or questions for the interview coordinator..."
                    : "Any notes or questions for the placement coordinator..."
                }
              />
            </>
          ) : (
            <>
              <Typography variant="body2" className="mb-3 text-muted">
                Please provide a reason for{" "}
                {placementDialogContext === "interview"
                  ? "declining the interview invitation"
                  : "rejecting the placement offer"}{" "}
                from <strong>{activePlacement?.company}</strong>.
              </Typography>

              {placementDialogContext === "interview" ? (
                <TextField
                  label="Reason *"
                  multiline
                  rows={3}
                  fullWidth
                  variant="outlined"
                  size="small"
                  required
                  inputProps={{ maxLength: 500 }}
                  helperText={`${rejectMessage.length}/500`}
                  value={rejectMessage}
                  onChange={(e) => setRejectMessage(e.target.value)}
                  placeholder="Let us know why you can't join the interview..."
                />
              ) : (
                <>
                  <Autocomplete
                    size="small"
                    className="mb-3"
                    options={placementRejectionReasons}
                    value={
                      placementRejectionReasons.find(
                        (r) => r.id === rejectReasonId,
                      ) || null
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.reason || ""}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.id}>
                        {option.reason}
                      </Box>
                    )}
                    onChange={(_, option) =>
                      setRejectReasonId(option ? option.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Rejection reason *"
                        size="small"
                        required
                      />
                    )}
                  />

                  {/* Warning when selected reason removes from waiting list */}
                  {(() => {
                    const selectedReason = placementRejectionReasons.find(
                      (r) => r.id === rejectReasonId,
                    );
                    if (!selectedReason?.isRemovedFromWaiting) return null;
                    if (selectedReason.id === 2) {
                      const count = application?.offerRejectionCount ?? 0;
                      const remaining = 3 - count - 1;
                      const usedLabel =
                        count === 0
                          ? "You have not rejected any offer yet."
                          : `You have used ${count} of your 3 rejection chances.`;
                      return (
                        <Alert severity="warning" className="mb-3">
                          {usedLabel} Rejecting this offer will use your{" "}
                          <strong>{count + 1} of 3</strong> chances and
                          permanently remove you from the internship waiting
                          list. You will have{" "}
                          <strong>
                            {remaining} chance{remaining !== 1 ? "s" : ""}
                          </strong>{" "}
                          remaining after this.
                        </Alert>
                      );
                    }
                    return (
                      <Alert severity="warning" className="mb-3">
                        Selecting this reason will permanently remove you from
                        the internship waiting list.
                      </Alert>
                    );
                  })()}

                  <TextField
                    label="Additional comments (optional)"
                    multiline
                    rows={3}
                    fullWidth
                    variant="outlined"
                    size="small"
                    inputProps={{ maxLength: 500 }}
                    helperText={`${rejectMessage.length}/500`}
                    value={rejectMessage}
                    onChange={(e) => setRejectMessage(e.target.value)}
                    placeholder="Any additional details about why you are declining..."
                  />
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions className="px-3 py-2">
          <Button
            onClick={() => setShowPlacementDialog(false)}
            variant="outlined"
            size="small"
            disabled={submittingOffer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={
              submittingOffer ||
              (placementDialogMode === "accept"
                ? !agreementChecked
                : placementDialogContext === "interview"
                  ? !rejectMessage.trim()
                  : !rejectReasonId)
            }
            color={placementDialogMode === "accept" ? "success" : "error"}
            startIcon={
              submittingOffer ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  style={{ width: "14px", height: "14px" }}
                />
              ) : placementDialogMode === "accept" ? (
                <ThumbUpIcon fontSize="small" />
              ) : (
                <ThumbDownIcon fontSize="small" />
              )
            }
            onClick={async () => {
              setSubmittingOffer(true);
              await respondToPlacementOffer(
                {
                  placementId: activePlacement?.placementId,
                  action:
                    placementDialogMode === "accept" ? "ACCEPT" : "REJECT",
                  comment:
                    placementDialogMode === "accept"
                      ? agreementMessage || null
                      : rejectMessage || null,
                  reasonId:
                    placementDialogMode === "reject" &&
                    placementDialogContext !== "interview"
                      ? rejectReasonId
                      : null,
                  context: placementDialogContext,
                },
                () => setShowPlacementDialog(false),
              );
              if (application?.applicationId) {
                getApplicationPlacements?.(application.applicationId);
              }
              setSubmittingOffer(false);
            }}
          >
            {submittingOffer
              ? placementDialogMode === "accept"
                ? "Accepting..."
                : "Rejecting..."
              : placementDialogMode === "accept"
                ? "Confirm Accept"
                : "Confirm Reject"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showRejectionDialog}
        onClose={() => setShowRejectionDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className="d-flex align-items-center">
            <NotificationImportantIcon
              className="mr-2"
              sx={{ color: "error.main" }}
            />
            Application Rejection Reason
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" className="mt-2">
            {application?.applicationRejectionReason ||
              "No rejection reason provided."}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowRejectionDialog(false)}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Placement Rejection Logs Dialog */}
      <Dialog
        open={showLogsDialog}
        onClose={() => setShowLogsDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="d-flex align-items-center justify-content-between">
            <span>Placement Rejection History</span>
            <IconButton size="small" onClick={() => setShowLogsDialog(false)}>
              <span className="material-icons" style={{ fontSize: "1.2rem" }}>
                close
              </span>
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {placementRejectionLogs.length === 0 ? (
            <Typography
              variant="body2"
              color="text.secondary"
              className="py-3 text-center"
            >
              No rejection logs found.
            </Typography>
          ) : (
            <div>
              {placementRejectionLogs.map((log, index) => (
                <Box
                  key={log.logId || index}
                  className="mb-3 p-3 rounded border"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  {/* Header row */}
                  <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                    <div className="d-flex align-items-center">
                      <ThumbDownIcon
                        fontSize="small"
                        className="mr-1 text-danger"
                      />

                      <span
                        className="badge badge-pill badge-danger ml-2"
                        style={{ fontSize: "0.75rem" }}
                      >
                        {log.rejectionReasonText || "—"}
                      </span>
                      {log.isRemovedFromWaiting ? (
                        <span
                          className="badge badge-pill badge-warning ml-1"
                          style={{ fontSize: "0.72rem" }}
                        >
                          Removed from waiting list
                        </span>
                      ) : null}
                    </div>
                    <Typography variant="caption" color="text.secondary">
                      {formatDateTime(log.logCreatedOn)}
                    </Typography>
                  </div>

                  <div className="row mx-0">
                    {/* Placement dates */}
                    <div className="col-6 col-md-3 mb-2 px-1">
                      <div className="text-muted small">Offer sent At</div>
                      <div className="font-weight-bold small">
                        {formatDateTime(log.offerSentOn)}
                      </div>
                    </div>

                    <div className="col-6 col-md-3 mb-2 px-1">
                      <div className="text-muted small">Rejections After</div>
                      <div
                        className="font-weight-bold small"
                        style={{
                          color:
                            log.offerRejectionCountAfter >= 3
                              ? "#dc3545"
                              : log.offerRejectionCountAfter === 2
                                ? "#fd7e14"
                                : "inherit",
                        }}
                      >
                        {log.offerRejectionCountAfter ?? "—"} / 3
                      </div>
                    </div>
                    <div className="col-6 col-md-3 mb-2 px-1">
                      <div className="text-muted small">Placement Status</div>
                      <div className="font-weight-bold small">
                        {log.placementStatusName || "—"}
                      </div>
                    </div>
                  </div>

                  {/* Rejected by + Comments */}
                  <div className="mt-2 px-1">
                    {(log.createdByFirstName || log.createdByLastName) && (
                      <div className="mb-1">
                        <span className="text-muted small">Rejected by: </span>
                        <span className="small font-weight-bold">
                          {[log.createdByFirstName, log.createdByLastName]
                            .filter(Boolean)
                            .join(" ")}
                        </span>
                      </div>
                    )}
                    {log.logComments && (
                      <div>
                        <div className="text-muted small">Comments</div>
                        <div className="small">{log.logComments}</div>
                      </div>
                    )}
                  </div>
                </Box>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions className="px-3 py-2">
          <Button
            variant="contained"
            size="small"
            onClick={() => setShowLogsDialog(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Correction Dialog */}
      <DialogModel
        isOpen={showConfirmCorrectionDialog}
        handleClose={() => {
          setShowConfirmCorrectionDialog(false);
          setAgreedToCorrections(false);
        }}
        title="Confirm Corrections"
        maxWidth="sm"
        isFullWidth
        footerContent={
          <div className="d-flex justify-content-end">
            <Button
              onClick={() => {
                setShowConfirmCorrectionDialog(false);
                setAgreedToCorrections(false);
              }}
              className="mr-2"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={async () => {
                if (!agreedToCorrections) {
                  showError(
                    "Please confirm that you have corrected all the issues",
                  );
                  return;
                }
                setConfirming(true);
                await confirmInternshipApplicationCorrection(
                  application.applicationId,
                  () => {
                    setShowConfirmCorrectionDialog(false);
                    setAgreedToCorrections(false);
                    setApplicationWithEdit(null);
                    getInternshipApplications(0, () => {});
                  },
                );
                setConfirming(false);
              }}
              variant="contained"
              color="primary"
              disabled={confirming || !agreedToCorrections}
            >
              {confirming ? "Confirming..." : "Confirm"}
            </Button>
          </div>
        }
      >
        <Box sx={{ py: 2 }}>
          <Alert severity="info" className="mb-3">
            <AlertTitle>Important Notice</AlertTitle>
            Please carefully review all corrections before confirming.
            <br />
            If the approver finds any other errors or issues, your application
            will be rejected permanently.
            <br />
            If you have any questions or concerns, please contact the support
            team via phone number{" "}
            <span className="font-weight-bold text-success">
              0788333752/0788333739
            </span>
            .
          </Alert>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreedToCorrections}
                onChange={(e) => setAgreedToCorrections(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body1">
                I confirm that I have corrected all the corrections the approver
                recommended/requested to correct.
              </Typography>
            }
          />
        </Box>
      </DialogModel>
    </section>
  );
};
